import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import logo from "../../assets/img/illustrations/logo.png";
import logo_bordered from "../../assets/img/illustrations/logo-bordered.png";

const Logo = ({
  to,
  at = "auth",
  width = 200,
  bordered,
  src = null,
  classImage = null,
  styleImage = null,
  className,
  ...rest
}) => {
  return (
    <>
      {to !== null ? (
        <Link
          to={to === undefined ? "/" : to}
          className={classNames(
            "text-decoration-none",
            { "navbar-brand text-left": at === "navbar-vertical" },
            { "navbar-brand text-left": at === "navbar-top" }
          )}
          {...rest}
        >
          <div
            className={classNames(
              "d-flex",
              {
                "align-items-center py-3": at === "navbar-vertical",
                "align-items-center": at === "navbar-top",
                "flex-center font-weight-extra-bold fs-5 mb-4": at === "auth",
              },
              className
            )}
          >
            <img
              style={styleImage ? styleImage : {}}
              className={"mx-2 " + classImage && classImage}
              src={src ? src : bordered ? logo_bordered : logo}
              alt="Logo"
              width={width}
            />
          </div>
        </Link>
      ) : (
        <span
          className={classNames(
            "text-decoration-none",
            { "navbar-brand text-left": at === "navbar-vertical" },
            { "navbar-brand text-left": at === "navbar-top" }
          )}
          {...rest}
        >
          <div
            className={classNames(
              "d-flex",
              {
                "align-items-center py-2": at === "navbar-vertical",
                "align-items-center": at === "navbar-top",
                "flex-center font-weight-extra-bold fs-5": at === "auth",
              },
              className
            )}
          >
            <img
              style={styleImage ? styleImage : {}}
              className={"mx-2 " + classImage && classImage}
              src={src ? src : bordered ? logo_bordered : logo}
              alt="Logo"
              width={width}
            />
          </div>
        </span>
      )}
    </>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(["navbar-vertical", "navbar-top", "auth"]),
  width: PropTypes.number,
  className: PropTypes.string,
};


export default Logo;
